module.exports = __webpack_public_path__ + "media/images/icon-business-model-4a6c75e3529d33dd14c1556f64c5bbeb.svg";